<template lang="pug">
#category-nav(:class="{ 'mobile': mobile }")
  .scroll-arrows
    .arrow.left
      i.el-icon-arrow-left
    .arrow.right
      i.el-icon-arrow-right
  overlay-scrollbars(ref="container" :options="{scrollbars: { visibility: 'hidden' },callbacks: { onScrollStop: onScrollStop } }")
    .nav-items(:style="{ width: `${navItemsWidth}px` }")
      v-touch.nav-item(v-for="tab in tabs" :class="{ active: isActive(tab.label) }" @tap="setActiveTab(tab.label)" :ref="`tab-${tab.label}`" :style="{ width: `${navItemWidth}px` }")
        .bar(:style="{ backgroundColor: tab.color }")
        .selected(:style="{ backgroundColor: tab.color }")
        .label {{ tab.label }}
        .count(v-if="!mobile && getCount(tab.label) > 0") {{ getCount(tab.label) }}
      .clearfix
  
</template>

<script>
import axios from "axios";
import { OverlayScrollbarsComponent } from "overlayscrollbars-vue";
import "overlayscrollbars/css/OverlayScrollbars.css";
import { mapGetters } from "vuex";

export default {
  name: "CategoryNav",
  components: {
    "overlay-scrollbars": OverlayScrollbarsComponent
  },
  props: {
    mobile: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(["category"])
  },
  watch: {
    category() {
      const el = this.$refs[`tab-${this.category}`][0].$el;
      this.$nextTick(() => {
        this.$refs.container.osInstance().scroll(
          {
            el: el,
            scroll: { x: "always", y: "never" },
            block: "center"
          },
          500,
          "easeOutSine"
        );
      });
    }
  },
  mounted() {
    this.loadMeta();
    if (this.$route.params.category) {
      this.setActiveTab(this.$route.params.category);
    }
    this.loadNavItemWidth();
  },
  data() {
    return {
      navItemWidth: 200,
      navItemsWidth: 1600,
      tabs: [
        { label: "everything", color: "#222222" },
        { label: "bmx", color: "#FF5D20" },
        { label: "moto", color: "#1410F9" },
        { label: "mtb", color: "#43822D" },
        { label: "skate", color: "#B11114" },
        { label: "ski", color: "#0CB824" },
        { label: "snow", color: "#D605D2" },
        { label: "surf", color: "#01ADC0" }
      ],
      counts: undefined
    };
  },
  methods: {
    onScrollStop() {
      let pos = this.$refs.container.osInstance().scroll().position.x;
      pos = pos + this.navItemWidth / 2;
      console.log("pos", pos);

      const newPos = `${parseInt(pos / this.navItemWidth) *
        this.navItemWidth}px`;
      console.log("newPos", newPos);

      this.$refs.container.osInstance().scroll(
        {
          x: newPos,
          y: 0
        },
        500,
        "easeOutSine"
      );
    },
    loadNavItemWidth() {
      const width = this.$refs.container.$el.clientWidth;
      this.navItemsWidth = this.tabs.length * width;
      this.navItemWidth = width;
    },
    getCount(label) {
      if (!this.counts) return 0;
      return this.counts[label] ? this.counts[label] : 0;
    },
    loadMeta() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/photos/meta`, {})
        .then(response => {
          this.counts = response.data.counts;
        });
    },
    setActiveTab(tab) {
      this.$router.push({ name: this.$route.name, params: { category: tab } });
      this.$store.dispatch("setCategory", tab);
    },
    isActive(tab) {
      return tab === this.category;
    }
  }
};
</script>

<style lang="stylus">
body.isNativeApp #category-nav {
  top: 0 !important;
}

#category-nav {
  border-radius();
  // border: $color-light-border 1px solid;
  background-color: white;
  margin: 20px 0;
  margin-left: 20px;
  padding-left: 4px;
  position: relative;
  overflow: hidden;
  position: fixed;
  z-index: 999;
  width: 260px;

  +tablet() {
    pinned(fixed);
    bottom: auto;
    top: $nav-size;
    width: auto;
  }

  .nav-item {
    // animate(all, 0.1s, ease-in-out);
    font-size: 0.9em;
    font-weight: bold;
    line-height: 50px;
    height: 50px;
    position: relative;
    text-align: left;
    text-transform: uppercase;
    white-space: nowrap;
    width: 100%;

    .bar {
      animate();
      // border-radius();
      pinned(absolute);
      pointer-events: none;
      right: auto;
      top: 4px;
      bottom: 4px;
      width: 5px;
    }

    .selected {
      animate();
      pinned(absolute);
      opacity: 0;
      pointer-events: none;
      z-index: 0;
    }

    &.active {
      border-bottom-color: transparent;
      color: white;
      color: black;

      .bar {
        width: 100%;
      }

      .label {
        color: white;
      }

      .selected {
        // opacity: 1;
      }

      .count {
        background-color: alpha(white, 0.3) !important;
      }
    }

    &:not(:last-child) {
      // border-bottom: $color-light-border 1px solid;
      &:after {
        background-color: $color-light-border;
        height: 1px;
      }
    }

    .label {
      animate();
      font-size: 0.9em;
      padding: 0 20px;
      position: relative;
    }

    .count {
      animate();
      pinned(absolute);
      border-radius(4px);
      background-color: $color-info;
      background-color: $color-border;
      color: white;
      left: auto;
      right: 10px;
      top: 15px;
      bottom: auto;
      font-size: 0.8em;
      padding: 0 8px;
      line-height: 20px;
    }

    &:hover {
      cursor: pointer;

      &:not(.active) {
        .bar {
          width: 8px;
        }
      }
    }
  }

  .scroll-arrows {
    display: none;
    // border-bottom: $color-light-border 1px solid;
    pinned(absolute);

    .arrow {
      animate();
      border-radius(50%);
      pinned(absolute, 5px);
      border-bottom: $color-light-border 1px solid;
      line-height: 40px;
      height: 40px;
      width: 40px;

      &:hover {
        background-color: $color-info;
        color: white;
        cursor: pointer;
      }

      &.right {
        border-left: $color-light-border 1px solid;
        left: auto;
      }

      &.left {
        border-right: $color-light-border 1px solid;
        right: auto;
      }
    }
  }

  &.mobile {
    background-color: #222;
    border-radius: 0;
    border: none;
    margin: 0;
    max-height: 50px;
    padding: 0;
    overflow-x: scroll;
    overflow-y: hidden;

    +tabletup() {
      display: none;
    }

    .scroll-arrows {
      opacity: 0;
    }

    // &:before, &:after {
    // pinned(absolute);
    // content: '';
    // pointer-events: none;
    // width: 40px;
    // z-index: 10;
    // }

    // &:before {
    // // background: linear-gradient(to left, rgba(250, 250, 250, 0), rgba(250, 250, 250, 1) 100%);
    // right: auto;
    // }

    // &:after {
    // background: linear-gradient(to right, rgba(250, 250, 250, 0), rgba(250, 250, 250, 1) 100%);
    // left: auto;
    // }
    .scroll-arrows {
      display: block;
    }

    .nav-items {
      // padding: 0 100px;
      .nav-item {
        background-color: white;
        float: left;
        padding: 0;
        text-align: center;
        // width: auto;
        width: 200px;

        .bar {
          border-radius(0);
          top: auto;
          width: auto;
          bottom: 0;
          height: 3px;
          right: 0;
          left: 0;
        }

        &:hover {
          background-color: white;

          .bar {
            height: 5px;
          }
        }

        &.active {
          color: white;
          text-align: center;

          .bar {
            height: 50px;
          }
        }
      }
    }
  }
}
</style>
